import React from 'react';
import PropTypes from 'prop-types';
import Button from './bootstrap/Button';

const EkhoLogo = ({ style }) => (
	<svg
		width='461'
		height='141'
		viewBox='0 0 461 141'
		fill='none'
		style={style}
		xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M30 138.182C13.4315 138.182 0 124.75 0 108.182V5.00001C0 2.23858 2.23858 0 5 0H95.2699C97.6548 0 99.5881 1.93332 99.5881 4.31818C99.5881 18.6274 87.9882 30.2273 73.679 30.2273H42.5142C39.7528 30.2273 37.5142 32.4659 37.5142 35.2273V48.9773C37.5142 51.7387 39.7528 53.9773 42.5142 53.9773H89.4602C92.2217 53.9773 94.4602 56.2158 94.4602 58.9773V79.2046C94.4602 81.966 92.2217 84.2046 89.4602 84.2046H42.5142C39.7528 84.2046 37.5142 86.4431 37.5142 89.2046V102.955C37.5142 105.716 39.7528 107.955 42.5142 107.955H94.3182C97.0796 107.955 99.3182 110.193 99.3182 112.955V133.182C99.3182 135.943 97.0796 138.182 94.3182 138.182H30Z'
			fill={style.fill || 'gray'}
		/>
		<path
			d='M152.199 113.622L152.469 69.3608H157.327L173.446 47.0014C179.085 39.18 188.14 34.5455 197.782 34.5455H214.049C218.207 34.5455 220.548 39.326 217.999 42.6111L182.156 88.7926H171.631L152.199 113.622ZM123.733 138.182C120.972 138.182 118.733 135.943 118.733 133.182V5.00001C118.733 2.23858 120.972 0 123.733 0H125.977C142.546 0 155.977 13.4315 155.977 30V133.182C155.977 135.943 153.739 138.182 150.977 138.182H123.733ZM185.579 138.182C183.795 138.182 182.146 137.231 181.252 135.687L158.946 97.1591L183.236 70.7102L220.567 130.535C222.645 133.865 220.25 138.182 216.325 138.182H185.579Z'
			fill={style.fill || 'gray'}
		/>
		<path
			d='M271.202 79.8864V133.182C271.202 135.943 268.963 138.182 266.202 138.182H238.958C236.196 138.182 233.958 135.943 233.958 133.182V5.00001C233.958 2.23858 236.196 0 238.958 0H239.853C256.421 0 269.853 13.4315 269.853 30V53.6147C269.853 53.964 270.136 54.2472 270.485 54.2472C270.753 54.2472 270.992 54.0776 271.084 53.826C273.438 47.4159 277.278 42.4059 282.605 38.7962C288.047 35.0627 294.592 33.196 302.239 33.196C309.571 33.196 315.936 34.8603 321.333 38.1889C326.776 41.5175 330.982 46.1056 333.951 51.9531C336.964 57.8007 338.449 64.5028 338.404 72.0597V133.182C338.404 135.943 336.165 138.182 333.404 138.182H306.159C303.398 138.182 301.159 135.943 301.159 133.182V79.8864C301.204 74.7585 299.922 70.7327 297.314 67.809C294.75 64.8852 291.084 63.4233 286.316 63.4233C283.302 63.4233 280.648 64.098 278.354 65.4474C276.105 66.7519 274.351 68.6411 273.091 71.1151C271.877 73.544 271.247 76.4678 271.202 79.8864Z'
			fill={style.fill || 'gray'}
		/>
		<path
			d='M406.719 140.071C395.473 140.071 385.848 137.844 377.841 133.391C369.834 128.893 363.694 122.641 359.421 114.634C355.148 106.583 353.011 97.2491 353.011 86.6335C353.011 76.018 355.148 66.7069 359.421 58.7003C363.694 50.6487 369.834 44.3963 377.841 39.9432C385.848 35.4451 395.473 33.196 406.719 33.196C417.964 33.196 427.59 35.4451 435.597 39.9432C443.603 44.3963 449.743 50.6487 454.016 58.7003C458.29 66.7069 460.426 76.018 460.426 86.6335C460.426 97.2491 458.29 106.583 454.016 114.634C449.743 122.641 443.603 128.893 435.597 133.391C427.59 137.844 417.964 140.071 406.719 140.071ZM406.989 112.543C410.137 112.543 412.859 111.486 415.153 109.371C417.447 107.257 419.223 104.244 420.483 100.33C421.742 96.4169 422.372 91.7614 422.372 86.3636C422.372 80.9209 421.742 76.2654 420.483 72.397C419.223 68.4837 417.447 65.4699 415.153 63.3558C412.859 61.2417 410.137 60.1847 406.989 60.1847C403.66 60.1847 400.804 61.2417 398.42 63.3558C396.036 65.4699 394.214 68.4837 392.955 72.397C391.695 76.2654 391.065 80.9209 391.065 86.3636C391.065 91.7614 391.695 96.4169 392.955 100.33C394.214 104.244 396.036 107.257 398.42 109.371C400.804 111.486 403.66 112.543 406.989 112.543Z'
			fill={style.fill || 'gray'}
		/>
	</svg>
);

EkhoLogo.propTypes = {
	style: PropTypes.shape({
		height: PropTypes.string,
		width: PropTypes.string,
		display: PropTypes.string,
		marginLeft: PropTypes.string,
		fill: PropTypes.string,
		opacity: PropTypes.string,
	}),
};

EkhoLogo.defaultProps = {
	style: {
		height: '11px',
		width: 'auto',
		display: 'inline-block',
		marginLeft: '5px',
		fill: 'gray',
		opacity: '0.8',
	},
};

const EkhoDealerFooter = ({
	stacked,
	linkTwoText,
	linkThreeText,
	linkFourText,
	linkTwoOnClick,
	linkThreeOnClick,
	linkFourOnClick,
}) => {
	return (
		<>
			{!stacked && (
				<div
					id='ekho-dealer-footer'
					style={{
						marginTop: '0',
						marginBottom: '0',
						fontFamily: "'Poppins', Helvetica, sans-serif",
						width: '100%',
						maxWidth: '400px',
						height: '20px',
					}}
					className='d-flex flex-row
					justify-content-center align-self-center'>
					<div
						className='d-flex flex-row justify-content-end col-6'
						style={{
							color: 'gray',
							opacity: '0.8',
							fontSize: 'small',
							height: '20px',
							borderRight: '1px solid rgba(128, 128, 128, 0.2)',
						}}>
						{' '}
						<div
							className='text-right'
							style={{
								marginRight: '16px',
								textAlign: 'right',
							}}>
							{' '}
							Powered by <EkhoLogo />
						</div>
					</div>
					<div
						className='d-flex flex-row col-6'
						style={{
							color: 'gray',
							opacity: '0.8',
							fontSize: 'small',
							height: '20px',
							paddingLeft: '16px',
						}}>
						<div className='col-4'>
							<Button
								className='button-hover-underline'
								style={{
									color: 'gray',
									border: 'none',
									background: 'none',
									padding: '0',
									fontWeight: 'normal',
								}}
								onClick={() => linkThreeOnClick()}>
								{linkThreeText}
							</Button>
						</div>
						<div className='col-4'>
							<Button
								className='button-hover-underline'
								style={{
									color: 'gray',
									border: 'none',
									background: 'none',
									padding: '0',
									fontWeight: 'normal',
								}}
								onClick={() => linkTwoOnClick()}>
								{linkTwoText}
							</Button>
						</div>
						<div className='col-4'>
							{linkFourText && (
								<Button
									className='button-hover-underline'
									style={{
										color: 'gray',
										border: 'none',
										background: 'none',
										padding: '0',
										fontWeight: 'normal',
									}}
									onClick={() => linkFourOnClick()}>
									{linkFourText}
								</Button>
							)}
						</div>
					</div>
				</div>
			)}
			{stacked && (
				<div
					id='ekho-dealer-footer'
					style={{
						marginTop: '0',
						marginBottom: '0',
						fontFamily: "'Poppins', Helvetica, sans-serif",
					}}
					className='d-flex flex-column justify-content-center align-items-center align-self-center'>
					<div
						className='d-flex flex-row row-12 m-1'
						style={{
							color: 'gray',
							opacity: '0.8',
							fontSize: 'small',
							height: '20px',
						}}>
						<div className='col-12 text-center'>
							{' '}
							Powered by <EkhoLogo />
						</div>
					</div>
					<div
						className='d-flex flex-row row-12 align-items-center justify-content-center'
						style={{
							color: 'gray',
							opacity: '0.8',
							fontSize: 'small',
							height: '20px',
							width: '250px',
						}}>
						<div className='col-3 text-center'>
							<Button
								className='button-hover-underline'
								style={{
									color: 'gray',
									border: 'none',
									background: 'none',
									padding: '0',
									fontWeight: 'normal',
								}}
								onClick={() => linkThreeOnClick()}>
								{linkThreeText}
							</Button>
						</div>
						<div className='col-3 text-center'>
							<Button
								className='button-hover-underline'
								style={{
									color: 'gray',
									border: 'none',
									background: 'none',
									padding: '0',
									fontWeight: 'normal',
								}}
								onClick={() => linkTwoOnClick()}>
								{linkTwoText}
							</Button>
						</div>
						{linkFourText && (
							<div className='col-3'>
								<Button
									className='button-hover-underline'
									style={{
										color: 'gray',
										border: 'none',
										background: 'none',
										padding: '0',
										fontWeight: 'normal',
									}}
									onClick={() => linkFourOnClick()}>
									{linkFourText}
								</Button>
							</div>
						)}
					</div>
				</div>
			)}
		</>
	);
};

EkhoDealerFooter.propTypes = {
	stacked: PropTypes.bool,
	linkTwoText: PropTypes.string,
	linkThreeText: PropTypes.string,
	linkFourText: PropTypes.string,
	linkTwoOnClick: PropTypes.func,
	linkThreeOnClick: PropTypes.func,
	linkFourOnClick: PropTypes.func,
};

EkhoDealerFooter.defaultProps = {
	stacked: false,
	linkTwoText: 'Privacy',
	linkThreeText: 'Terms',
	linkFourText: 'Chat',
	linkTwoOnClick: () => {
		// Open ekhoDealer.com in new tab
		window.open('https://www.ekhodealer.com/ekho-direct-privacy', '_blank');
	},
	linkThreeOnClick: () => {
		// Open ekhoDealer.com in new tab
		window.open('https://www.ekhodealer.com/ekho-direct-terms', '_blank');
	},
	linkFourOnClick: () => {
		// Open ekhoDealer.com in new tab
		window.open('https://www.ekhodealer.com/', '_blank');
	},
};
export default EkhoDealerFooter;
